import React from "react";
import Free_Consultation from "../../home/free-consultation/Free_Consultation";
import Inner_Page_Banner from "./inner-page-banner/Inner_Page_Banner";
import Include_Services from "./include-services/Include_Services";
import Key_Benefits from "./key-benefits/Key_Benefits";
import Rooftop_Solar from "./rooftop-solar/Rooftop_Solar";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const Service_Inner_Page = () => {
  const { id } = useParams();

  const seoData = {
    17: {
      title: "Duct Inline Fan for Efficient Ventilation | AYZAIR",
      description:
        "AYZAIR Duct Inline Fans deliver high-performance air circulation with quiet operation and durable construction. Ideal for HVAC and ventilation systems. Get a quote now and improve your airflow with AYZAIR!",
    },
    16: {
      title: "Hammer Exhaust Fans for Powerful Airflow | AYZAIR",
      description:
        "Enhance air quality with AYZAIR Hammer Exhaust Fans. Built for high airflow, durability, and energy efficiency, they ensure a fresh and comfortable environment. Get a quote now and choose AYZAIR for reliable ventilation solutions!",
    },
    15: {
      title: "High Volume Air Circulation Fan Solutions | AYZAIR",
      description:
        "Improve ventilation and comfort with AYZAIR High Volume Air Circulation Fans. Engineered for maximum airflow, durability, and low operating costs. Get a quote now and enhance your space with AYZAIR!",
    },
    13: {
      title: "Duct Air Cooler for Industrial Cooling | AYZAIR",
      description:
        "AYZAIR Duct Air Coolers provide high-performance cooling with superior air distribution, low energy consumption, and reliable operation. Perfect for large spaces and ventilation systems. Get a quote now and experience efficient cooling with AYZAIR!",
    },
    7: {
      title: "Portable Air Cooler for Efficient Cooling | AYZAIR",
      description:
        "AYZAIR Portable Air Coolers deliver effective cooling, low power consumption, and convenient portability for any space. Stay comfortable all summer long. Get a quote now and experience refreshing cooling with AYZAIR!",
    },
  };

  const url = `https://www.ayzair.com/explore-produtcs/${id}`;

  const seo = seoData[id] || {
    title: "Products | AYZAIR",
    description: "Explore AYZAIR's premium cooling and ventilation products.",
  };

  return (
    <>
      <Helmet>
        <title>{seo.title}</title>
        <meta name="title" content={seo.title} />
        <meta name="description" content={seo.description} />
        <link rel="canonical" href={url} />
      </Helmet>
      <Inner_Page_Banner />
      <Rooftop_Solar />
    </>
  );
};

export default Service_Inner_Page;
